import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'

export const getInventoryLogsAsync = createAsyncThunk(
  'orders/getInventoryLogsAsync',
  async function (
    params: {
      paramData: {page_num: number; page_limit?: number; sort_by: string; sort_order: string;status:string;from_date?:string;to_date?:string;
      platform_id:any; variant_id?: any; location?: string }

    },
    toolkit
  ) {
    return await AxiosClient(
      'GET',
      `/api/inventory-logs`,
      [],
      toolkit,
      params.paramData,
           toolkit.signal
    )
  }
)

export const getAllInventoryLocationsAsync = createAsyncThunk(
  'inventory/getAllInventoryLocationsAsync',
  async function (_, toolkit) {
    return await AxiosClient(
      'GET',
      `/api/all-inventory-location`,
      [],
      toolkit,
      {},
      toolkit.signal
    )
  }
)

export const resyncFailedInventoryAsync = createAsyncThunk(
  'inventory/resyncFailedInventoryAsync',
  async function (
    params: {product_variant_id: number | null; sync_id: number | null},
    toolkit
  ) {
    const query = new URLSearchParams({
      product_variant_id:
        params.product_variant_id === null ? 'null' : String(params.product_variant_id),
      sync_id: params.sync_id === null ? 'null' : String(params.sync_id),
    }).toString()

    return await AxiosClient('POST', `/api/resync-failed-inventory?${query}`, {}, toolkit, {})
  }
)
